import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getRseeAboutUsTextLoading: false,
  getRseeAboutUsTextFailed: false,
  getRseeAboutUsTextReject: false,
  getRseeAboutUsTextMessage: [],
  aboutRseeText: [],

  getAllCitiesLoading: true,
  getAllCitiesFailed: false,
  getAllCitiesReject: false,
  getAllCitiesMessage: [],
  citiesList: [],

  setCityCodeLoading: false,
  setCityCodeFailed: false,
  setCityCodeReject: false,
  setCityCodeMessage: [],

  getAvatarsListLoading: false,
  getAvatarsListFailed: false,
  getAvatarsListReject: false,
  avatars: [],

  setUserAvatarLoading: false,
  setUserAvatarFailed: false,
  setUserAvatarReject: false,
  uploadedAvatar: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_RSEE_ABOUT_US_TEXT_LOADING: {
      return {
        ...state,
        getRseeAboutUsTextLoading: true,
        getRseeAboutUsTextFailed: false,
        getRseeAboutUsTextReject: false,
        getRseeAboutUsTextMessage: [],
        aboutRseeText: [],
      };
    }
    case actionTypes.GET_RSEE_ABOUT_US_TEXT_SUCCESS: {
      return {
        ...state,
        getRseeAboutUsTextLoading: false,
        getRseeAboutUsTextFailed: false,
        getRseeAboutUsTextReject: false,
        getRseeAboutUsTextMessage: [],
        aboutRseeText: action.payload,
      };
    }
    case actionTypes.GET_RSEE_ABOUT_US_TEXT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getRseeAboutUsTextLoading: false,
        getRseeAboutUsTextFailed: true,
        getRseeAboutUsTextReject: false,
        getRseeAboutUsTextMessage: message,
        aboutRseeText: [],
      };
    }
    case actionTypes.GET_RSEE_ABOUT_US_TEXT_REJECT: {
      return {
        ...state,
        getRseeAboutUsTextLoading: false,
        getRseeAboutUsTextFailed: false,
        getRseeAboutUsTextReject: true,
        getRseeAboutUsTextMessage: [],
        aboutRseeText: [],
      };
    }

    case actionTypes.GET_ALL_CITIES_LOADING: {
      return {
        ...state,
        getAllCitiesLoading: true,
        getAllCitiesFailed: false,
        getAllCitiesReject: false,
        getAllCitiesMessage: [],
        citiesList: [],
      };
    }
    case actionTypes.GET_ALL_CITIES_SUCCESS: {
      return {
        ...state,
        getAllCitiesLoading: false,
        getAllCitiesFailed: false,
        getAllCitiesReject: false,
        getAllCitiesMessage: [],
        citiesList: action.payload.cities,
      };
    }
    case actionTypes.GET_ALL_CITIES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getAllCitiesLoading: true,
        getAllCitiesFailed: true,
        getAllCitiesReject: false,
        getAllCitiesMessage: message,
        citiesList: [],
      };
    }
    case actionTypes.GET_ALL_CITIES_REJECT: {
      return {
        ...state,
        getAllCitiesLoading: true,
        getAllCitiesFailed: false,
        getAllCitiesReject: true,
        getAllCitiesMessage: [],
        citiesList: [],
      };
    }

    case actionTypes.SET_CITY_CODE_LOADING: {
      return {
        ...state,
        setCityCodeLoading: true,
        setCityCodeFailed: false,
        setCityCodeReject: false,
        setCityCodeMessage: [],
      };
    }
    case actionTypes.SET_CITY_CODE_SUCCESS: {
      return {
        ...state,
        setCityCodeLoading: false,
        setCityCodeFailed: false,
        setCityCodeReject: false,
        setCityCodeMessage: [],
      };
    }
    case actionTypes.SET_CITY_CODE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        setCityCodeLoading: false,
        setCityCodeFailed: true,
        setCityCodeReject: false,
        setCityCodeMessage: message,
      };
    }
    case actionTypes.SET_CITY_CODE_REJECT: {
      return {
        ...state,
        setCityCodeLoading: false,
        setCityCodeFailed: false,
        setCityCodeReject: true,
        setCityCodeMessage: [],
      };
    }

    case actionTypes.GET_AVATAR_LIST_LOADING: {
      return {
        ...state,
        getAvatarsListLoading: true,
        getAvatarsListFailed: false,
        getAvatarsListReject: false,
        avatars: [],
      };
    }
    case actionTypes.GET_AVATAR_LIST_FAILED: {
      return {
        ...state,
        getAvatarsListLoading: true,
        getAvatarsListFailed: true,
        getAvatarsListReject: false,
        avatars: [],
      };
    }
    case actionTypes.GET_AVATAR_LIST_REJECT: {
      return {
        ...state,
        getAvatarsListLoading: true,
        getAvatarsListFailed: false,
        getAvatarsListReject: true,
        avatars: [],
      };
    }
    case actionTypes.GET_AVATAR_LIST_SUCCESS: {
      return {
        ...state,
        getAvatarsListLoading: false,
        getAvatarsListFailed: false,
        getAvatarsListReject: false,
        avatars: action.payload.images,
      };
    }

    case actionTypes.SET_USER_AVATAR_LOADING: {
      return {
        ...state,
        setUserAvatarLoading: true,
        setUserAvatarFailed: false,
        setUserAvatarReject: false,
        uploadedAvatar: [],
      };
    }
    case actionTypes.SET_USER_AVATAR_FAILED: {
      return {
        ...state,
        setUserAvatarLoading: false,
        setUserAvatarFailed: true,
        setUserAvatarReject: false,
        uploadedAvatar: [],
      };
    }
    case actionTypes.SET_USER_AVATAR_REJECT: {
      return {
        ...state,
        setUserAvatarLoading: false,
        setUserAvatarFailed: false,
        setUserAvatarReject: true,
        uploadedAvatar: [],
      };
    }
    case actionTypes.SET_USER_AVATAR_SUCCESS: {
      return {
        ...state,
        setUserAvatarLoading: false,
        setUserAvatarFailed: false,
        setUserAvatarReject: false,
        uploadedAvatar: action.payload.uploadedFileNames,
      };
    }

    default:
      return state;
  }
};
